import ComponentWithSocket from '../../../lib/component';
import { Component } from 'vue-property-decorator';

import moment from 'moment';
import 'moment/locale/ro';
moment.locale('ro');

@Component
export default class Auctions extends ComponentWithSocket {
    data: any = {
        auctions: [],
        auctionsCount: 0,
        perPage: 25,
        currentPage: 1,
    };

    constructor() {
        super();

        this.wsListener.onGet(
            'auctions.paginated',
            (success: boolean, data: any) => {
                this.data.auctions = [];

                if (success) {
                    this.data.auctionsCount = data.auctionsCount;

                    for (let auction of data.auctions) {
                        auction.startDate = auction.startDate
                            ? moment(auction.startDate)
                            : undefined;

                        this.data.auctions.push(auction);
                    }
                }

                this.loading(false);
            },
        );
    }

    reloadAuctions(page: any = this.data.currentPage) {
        this.loading(true);
        this.data.currentPage = page;

        this.wsListener.sendGet('auctions.paginated', {
            perPage: this.data.perPage,
            currentPage: page,
        });
    }

    auctionSiteUrl(auction: any): string {
        const baseUrl = 'https://vikart.ro/auction/';
        const adminToken = 'c4ca4238a0b923820dcc509a6f75849b';

        return `${baseUrl}${auction._id}?admin=${adminToken}`;
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from);
        next();
    }

    mounted() {
        this.reloadAuctions(1);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/auctions/list/index.ts